// extracted by mini-css-extract-plugin
export default {"kvRow":"KeyValueItem_kvRow__XjNvY","kvKey":"KeyValueItem_kvKey__2DmSr","kvValue":"KeyValueItem_kvValue__W3uvA","removeBtn":"KeyValueItem_removeBtn__dIH5I"};